import { configureStore as rtkConfigureStore } from "@reduxjs/toolkit";
import { createReducer } from "./reducers/index";
import analyticsMiddleware from "./middlewares/analyticsMiddleware";
import * as api from "./api";
import localRepository from "./localRepository";
import { jwtDecode } from "jwt-decode";
import {
  onAuthStatusChangeMiddleware,
  onToggleMainMenuMiddleware,
  onShowNativePopupMiddleware,
} from "./componentes/nativeAppMessaging/js/middleware";

import { createLogRemoteError } from "./libs/createLogRemoteError";
import dynamicMiddlewares from "./middlewares/dynamicMiddlewares";

import {
  checkErrorAction,
  getErrorMessage,
  getErrorCode,
  isTokenExpiredError,
} from "./libs/checkError";

import { sendMessage, sendError } from "./libs/sendMessage";

import { logOutUser } from "./componentes/user/js/actions";
import fileService from "libs/fileService";

const defaultServices = {
  api,
  fileService,
  errorHandler: {
    checkErrorAction: checkErrorAction,
    getErrorMessage,
    sendError,
    isTokenExpiredError,
    logOutUser,
    logRemoteError: createLogRemoteError(),
    getErrorCode,
  },
  sendMessage,
  localStorage: localRepository,
  jwt_decode: jwtDecode,
};

export default function configureStore(
  initialState,
  services = defaultServices
) {
  const store = rtkConfigureStore({
    reducer: createReducer(),
    preloadedState: initialState,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: { extraArgument: services },
      }).concat(
        analyticsMiddleware,
        onAuthStatusChangeMiddleware,
        onToggleMainMenuMiddleware,
        onShowNativePopupMiddleware,
        dynamicMiddlewares
      ),
  });
  store.asyncReducers = {};
  return store;
}

export function injectAsyncReducer(store, name, asyncReducer) {
  store.asyncReducers[name] = asyncReducer;
  store.replaceReducer(createReducer(store.asyncReducers));
}
